export default "__VITE_ASSET__e00e8364__"